import React from 'react';
import ChartGoal from 'charts/ChartGoal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
class GreenIndentedSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  toggleCollapse(event) {
    let btn = $(event.target);
    btn.next('.collapse').collapse('toggle');
    let icon = btn.find('.fas');
    if (icon.hasClass('fa-sort-up')) {
      icon.removeClass('fa-sort-up').addClass('fa-sort-down')
    } else {
      icon.removeClass('fa-sort-down').addClass('fa-sort-up')
    }
  }

  render() {
    return (
      <>
        <div className="row styled-indent-green dashboard-section">
          <div className="col-12 pt-1 pl-3">
            <h4 className="float-left">
              {this.props.sectionTitle}
            </h4>
            <div className="react-collapser float-right" onClick={(e) => this.toggleCollapse(e)}>
              <p style={{ fontSize: "16px" }} className="text-primary mb-0">Collapse Section&nbsp;<i className="fas fa-sort-up"></i></p>
            </div>
            <div className="no-gutters clear-both off-color-bg collapse show dashboard-section-inner">
              {
                this.props.children
              }
            </div>
            <div className="clear-both"></div>
            <div style={{borderBottom: "#E1E1E1 solid 2px"}}></div>
          </div>
        </div>
        <div className="clear-both"></div>
      </>
    )
  }

}

export default GreenIndentedSection;
